import { Box } from "@chakra-ui/react";
import CDS from "design-system";
import { GenericAsyncSelect } from "components/Form/Select/GenericAsyncSelect";
import { SelectFieldProps } from "components/Form/typings";
import { API_ROUTES } from "definitions/constants/routeConstants";
import { User } from "features/User/models";
import FormField from "../FormField";

export default function UserSelectField({
  name,
  label,
  helperText,
  errors,
  required,
  variant,
  placeholder = "User Search (start typing...)",
  formFieldProps = {},
  containerStyles = {},
  onChangeCallback,
  ...props
}: SelectFieldProps<User>) {
  const formVariant = variant;

  return (
    <FormField
      name={name}
      label={label}
      errors={errors}
      helperText={helperText}
      required={required}
      variant={formVariant}
      {...formFieldProps}
    >
      <GenericAsyncSelect
        fetchPath={API_ROUTES.users.search}
        perPagePagination={300}
        embedOption={(user) => ({
          value: user.id,
          label: (
            <Box>
              <CDS.Text14 lineHeight="short">{user.fullName ?? ""}</CDS.Text14>
              {user.workEmail && (
                <CDS.Text12 color="content.tertiary" lineHeight="short">
                  {user.workEmail}
                </CDS.Text12>
              )}
            </Box>
          ),
          rawValue: user,
        })}
        extractValue={(user) => user.id}
        name={name}
        variant={formVariant}
        placeholder={formVariant === "floating" ? " " : placeholder}
        containerStyles={{ width: "100%", ...containerStyles }}
        onChangeCallback={onChangeCallback}
        {...props}
      />
    </FormField>
  );
}
